import { Number, Record, String } from "runtypes";
export const ShareableRating = Record({
  id: String,
  rating: Number
});
//# sourceMappingURL=rating.js.map
